import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import SvelteMarkdown from "../../../../node_modules/@humanspeak/svelte-markdown/dist/index.js";
import { KatexRenderer, markedKatex } from "../../../../node_modules/@humanspeak/svelte-markdown/dist/extensions/index.js";
import PlaygroundSlexCode from "./PlaygroundSlexCode.svelte";

var root = $.from_html(`<div class="slex-doc-prose slex-doc-streamdown"><!></div>`);

export default function PlaygroundMarkdown($$anchor, $$props) {
	$.push($$props, true);

	const extensions = [markedKatex({ singleDollarInline: true })];
	const renderers = { inlineKatex: KatexRenderer, blockKatex: KatexRenderer };
	const options = { headerIds: false };

	function stripFrontmatter(value) {
		const raw = String(value ?? "").replace(/^\uFEFF/, "").replace(/\r\n/g, "\n");

		if (!raw.startsWith("---")) return raw;

		const end = raw.indexOf("\n---", 3);

		if (end === -1) return raw;

		const closeEnd = raw.indexOf("\n", end + 1);

		return raw.slice(closeEnd === -1 ? raw.length : closeEnd + 1).trimStart();
	}

	function escapeHtml(value) {
		return String(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
	}

	function stripInlineMarkdown(value) {
		return String(value).replace(/\s+\{#[A-Za-z0-9_-]+\}\s*$/, "").replace(/`([^`]+)`/g, "$1").replace(/\*\*([^*]+)\*\*/g, "$1").replace(/\*([^*]+)\*/g, "$1").replace(/\[([^\]]+)\]\([^)]+\)/g, "$1").replace(/<[^>]+>/g, "").replace(/\s+#+\s*$/, "").trim();
	}

	function slugText(value) {
		const slug = String(value).toLowerCase().replace(/[`"'\u2018\u2019\u201c\u201d]/g, "").replace(/[^a-z0-9\u4e00-\u9fa5]+/g, "-").replace(/^-+|-+$/g, "");

		return slug || "section";
	}

	function createHeadingIdGenerator() {
		const counts = new Map();

		return (rawTitle) => {
			const explicit = rawTitle.match(/\s+\{#([A-Za-z0-9_-]+)\}\s*$/)?.[1] ?? "";
			const base = explicit || slugText(stripInlineMarkdown(rawTitle));
			const count = counts.get(base) ?? 0;

			counts.set(base, count + 1);

			return count ? `${base}-${count + 1}` : base;
		};
	}

	function normalizeHeadingAnchors(markdown) {
		const nextId = createHeadingIdGenerator();
		let fence = null;

		return String(markdown ?? "").split(/\n/).map((line) => {
			const marker = String(line).match(/^[ \t]{0,3}(`{3,}|~{3,})/);

			if (fence) {
				if (marker && marker[1][0] === fence.char && marker[1].length >= fence.length) fence = null;

				return line;
			}

			if (marker) {
				fence = { char: marker[1][0], length: marker[1].length };

				return line;
			}

			const heading = String(line).match(/^(#{1,6})[ \t]+(.+)$/);

			if (!heading) return line;

			const rawTitle = heading[2].replace(/\s+#+\s*$/, "");
			const renderedTitle = rawTitle.replace(/\s+\{#[A-Za-z0-9_-]+\}\s*$/, "").trim();

			return `<span id="${escapeHtml(nextId(rawTitle))}" class="slex-doc-heading-anchor"></span>\n${heading[1]} ${renderedTitle}`;
		}).join("\n");
	}

	function previewMarkdown(value) {
		return normalizeHeadingAnchors(stripFrontmatter(value));
	}

	var div = root();
	var node = $.child(div);

	{
		const code = ($$anchor, $$arg0) => {
			let lang = () => ($$arg0?.()).lang;
			let text = () => ($$arg0?.()).text;

			PlaygroundSlexCode($$anchor, {
				get lang() {
					return lang();
				},

				get text() {
					return text();
				},

				get domain() {
					return $$props.domain;
				}
			});
		};

		let $0 = $.derived(() => previewMarkdown($$props.content));

		SvelteMarkdown(node, {
			get source() {
				return $.get($0);
			},

			get extensions() {
				return extensions;
			},

			get renderers() {
				return renderers;
			},

			get options() {
				return options;
			},
			code,
			$$slots: { code: true }
		});
	}

	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}